<template>
  <div class="third thisNew">
    <div class="third-formOne newSlideshow">
      <div class="formOne-btn">
        <div class="btn-left">
          <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>
          <span class="left-back-content">应用卡片列表》新增应用卡片</span>
        </div>
        <div class="btn-right">
          <el-button @click="commit()" class="btn-two" type="primary" v-el-disabel-repeat-click>保存</el-button>
          <el-button @click="resetForm('ruleForm')" class="btn-two" type="default">重置</el-button>
        </div>
      </div>
      <el-form
        @validate="validateValue"
        :show-message="false"
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="86px"
      >
        <div class="formOne-forms">
          <div class="forms-one" style="margin-top: 57px;">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">基本信息</span>
              </div>
            </div>
            <div class="one-list">
              <div class="list-one-line">
                <el-form-item label="卡片名称" prop="cardName">
                  <el-input
                    class="list-input"
                    :maxlength="20"
                    v-model.trim="ruleForm.cardName"
                    placeholder="请输入"
                  ></el-input>
                </el-form-item>
                <el-form-item label="安装部署包">
                  <el-upload
                    ref="upload"
                    class="list-upload-file"
                    action="noUse"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :on-success="handleSuccess"
                    :before-remove="beforeRemove"
                    :http-request="uploadSectionFile"
                    multiple
                    :limit="1"
                    :on-exceed="handleExceed"
                    :file-list="fileList"
                  >
                    <el-button class="upload-btn" type="default" icon="el-icon-upload2">点击上传</el-button>
                    <div slot="tip" class="list-upload-tip">50M以内，支持扩展名.zip</div>
                  </el-upload>
                </el-form-item>
              </div>
              <div class="list-one-line">
                <el-form-item label="卡片顺序" prop="sort">
                  <el-input
                    class="list-input"
                    :maxlength="3"
                    v-model.trim="ruleForm.sort"
                    placeholder="请输入0或正整数"
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="forms-one">
            <div class="one-title">
              <div class="title-left">
                <span class="left-icon">
                  <i class="el-icon-s-operation"></i>
                </span>
                <span class="left-content">授权信息</span>
              </div>
            </div>
            <div class="one-list">
              <template v-for="(row, index) in managerList">
                <el-form-item :label="'管理员'　+　(index + 1)" :key="index + row">
                  <key-value-select
                    style="display:inline-block"
                    :className="'list-input'"
                    v-model="managerList[index].adminId"
                    placeholder="请输入姓名后选择"
                    :autoSearch="true"
                    :openSearch="true"
                    :isNeedCash="false"
                    @SelectLabel="(value)=> {
                      row.adminName = value
                    }"
                    dictUrl="/api/blade-plugins/platformapplycard/getTeacherNameAndTeacherId"
                  ></key-value-select>
                  <div class="modal-func-icon" :key="index">
                    <el-button
                      class="content-icon-del"
                      icon="el-icon-minus"
                      @click="delItem(index)"
                      style="border-radius: 2px"
                    ></el-button>
                    <el-button
                      class="content-icon-add"
                      icon="el-icon-plus"
                      style="border-radius: 2px"
                      @click="addItem"
                    ></el-button>
                  </div>
                </el-form-item>
              </template>
              <el-form-item label="使用角色">
                <el-tag
                  style="margin-right:8px;"
                  v-for="tag in roleNametags"
                  :key="tag.name"
                  closable
                  :type="tag.type"
                  @close="handleClose(tag)"
                >{{tag.name}}</el-tag>
                <el-button type="default" icon="el-icon-plus" @click="openRoleName()">新增</el-button>
              </el-form-item>
              <el-form-item label="使用标签">
                <el-tag
                  style="margin-right:8px;"
                  v-for="tag in labletags"
                  :key="tag.name"
                  closable
                  :type="tag.type"
                  @close="handleCloselable(tag)"
                >{{tag.name}}</el-tag>
                <el-button type="default" icon="el-icon-plus" @click="openlableName()">新增</el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <new-task-modal
      class="detail-modal new-transfer-modal push-transferBody"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="detailModal"
      @closeNewTask="closeDetail"
      @addNewTask="agreeDetail"
      agreeBtn="确定"
      modalTitle="新增授权角色"
    >
      <div slot="content">
        <el-tree
          :data="treeData"
          node-key="id"
          show-checkbox
          :expand-on-click-node="false"
          :render-content="renderContent"
          @check="handlecheckd"
        ></el-tree>
      </div>
    </new-task-modal>
    <new-task-modal
      class="detail-modal new-transfer-modal push-transferBody"
      :closeonclickmodal="closeonclickmodal"
      :newModalVisible="lableTreeModal"
      @closeNewTask="closelable"
      @addNewTask="agreelable"
      agreeBtn="确定"
      modalTitle="新增授权标签"
    >
      <div slot="content">
        <el-tree
          :data="treelableData"
          node-key="id"
          show-checkbox
          :expand-on-click-node="false"
          :render-content="renderContent"
          @check="handleCheckChange"
        ></el-tree>
      </div>
    </new-task-modal>
  </div>
</template>

<script>
import {
  selectTree,
  selectlableTree,
  uploadFile,
  add
} from "@/api/cardsManage/cards";

export default {
  name: "formSeven",
  //   props: ["ID"],
  data () {
    return {
      closeonclickmodal: false, //是否开启点击空白处关闭弹窗
      detailModal: false, // 授权角色标签弹窗
      treeData: [], // 树节点数据
      roleTree: [], //被选中的角色标签
      lableTreeModal: false, //授权标签弹窗
      treelableData: [], //标签树节点
      lableTree: [], //被选中的标签列表
      countNum: 1, //用于显示第一个错误
      fileList: [
        // {
        //   name: "food.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        // },
        // {
        //   name: "food2.jpeg",
        //   url:
        //     "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100"
        // }
      ], // 上传文件列表
      rules: {
        sort: [
          { required: true, pattern: /^([0]|[1-9][0-9]*)$/, message: "请输入卡片顺序（0或正整数）", trigger: "blur" },
        ],
        cardName: [{ required: true, message: "请输入卡片名称", trigger: "blur" }],
        imgUrl: [{ required: true, message: "请上传图片", trigger: "blur" }],
        status: [{ required: true, message: "请选择状态", trigger: "blur" }]
      },
      ruleForm: {
        cardName: "", //卡片名称
        sort: "", // 卡片顺序
        jar: "", // 安装部署包
        adminId: "", // 管理员的id
        adminName: "", //管理员的名字
        roleId: "", // 角色id，多个角色逗号隔开
        lableId: "" //标签id，多个标签逗号隔开
      },
      tags: [
        { name: "标签一", type: "", id: "" },
        { name: "标签二", type: "success", id: "" },
        { name: "标签三", type: "info", id: "" },
        { name: "标签四", type: "warning", id: "" },
        { name: "标签五", type: "danger", id: "" }
      ],
      roleNametags: [], //授权角色标签数组
      labletags: [], //授权标签数组
      upData: {}, //上传文件信息
      managerList: [
        {
          adminId: '',
          adminName: ''
        }
      ]
    };
  },
  watch: {
    managerList(){
      let repeatId = ''
      console.log("managerList",this.managerList)

      this.managerList.forEach(fa => {
        let index = 0
        this.managerList.forEach(ch => {
          if(fa.adminId === ch.adminId && fa.adminId !== "") {
            index += 1
          }
        });
        if (index > 1){
          repeatId = fa.adminId
        }
      });
      console.log("repeatId", repeatId)
      if (repeatId !== ''){
        for (let index = 0; index < this.managerList.length; index++) {
          const element = this.managerList[index];
          if (element.adminId === repeatId) {
            this.managerList.splice(index,1)
            break
          }
        }
      }
    } 
  },
  created () {
    // this.selectTree();
  },
  methods: {
    delItem (index) {
      this.managerList.splice(index,1)
    },
    addItem () { 
      this.managerList.push({
        adminId: '',
        adminName: ''
      })
    },
    goBack () {
      this.$emit("backHome");
    },
    //删除标签
    handleClose (tag) {
      console.log("tag", this.roleNametags.indexOf(tag));
      this.roleNametags.splice(this.roleNametags.indexOf(tag), 1);
    },
    //删除标签
    handleCloselable (tag) {
      console.log("tag", this.labletags.indexOf(tag));
      this.labletags.splice(this.labletags.indexOf(tag), 1);
    },
    //文件列表移除文件时的钩子
    handleRemove (file, fileList) {
      console.log(file, fileList);
    },
    //文件上传成功时的钩子
    handleSuccess () {
      //   this.ruleFormImport.isfile = "1";
    },
    //点击文件列表中已上传的文件时的钩子
    handlePreview (file) {
      console.log(file);
    },
    //文件超出个数限制时的钩子
    handleExceed (files, fileList) {
      this.$message.warning('只能上传一个部署包');
      //   this.$message.warning(
      //     `当前限制选择 3 个文件，本次选择了 ${
      //       files.length
      //     } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      //   );
    },
    //删除文件之前的钩子
    beforeRemove (file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    //上传文件
    uploadSectionFile (params) {
      //   debugger;
      const file = params.file,
        fileType = file.type,
        isExcel =
          fileType.indexOf("sheet") != -1 || fileType.indexOf("ms-excel") != -1,
        isLt30M = file.size / 1024 / 1024 <= 50,
        isZIP = params.file.name.indexOf(".zip") !== -1;
      if (!isZIP) {
        this.$message.error("只支持文件扩展名.zip");
        return (this.fileList = []);
      }
      //   if (!isExcel) {
      //     this.$message.error("只支持文件扩展名.xls、.sxls");
      //     return (this.ruleFormImport.fileList = []);
      //   }
      if (!isLt30M) {
        this.$message.error("上传文件大小不得大于50M");
        console.log(this.fileList)
        return (this.fileList = []);
      }
      const form = new FormData();
      // 文件对象
      form.append("file", file);
      //   if (this.actionUplodeDate !== null) {
      //     form.append("tenantId", this.userInfo.tenant_id);
      //     console.log("id", this.uplodeDate.id);
      //     form.append("id", this.uplodeDate.id);
      //   } else {
      //     form.append("tenantId", this.userInfo.tenant_id);
      //   }
      uploadFile(form)
        .then(res => {
          const code = res.data;
          console.log("看看", res.data);
          //   && parseInt(res.status, 10);
          if (code.status === 1000) {
            // this.ruleFormImport.isfile = "1";
            this.upData = code.result;
            console.log("aaaaaaaaaawww", this.upData);
          } else {
            this.fileList = [];
            this.upData = {};
            this.$message.error(code.msg);
          }
        })
        .catch(err => {
          this.fileList = [];
          this.$message.error(err);
        });
    },
    // async facUpload(params) {
    //   console.log(params);
    //   try {
    //     let reqData = new FormData();
    //     reqData.append("tenantId", this.$store.state.user.tenantId);
    //     reqData.append("file", params.file);
    //     // const reqData = {
    //     //   tenantId: this.$store.state.user.tenantId, //大学id  （当前登录用户id）
    //     //   file:params.file
    //     // };
    //     await upicon(reqData).then(res => {
    //       const data = res.data;
    //       console.log("这是图片上传接口", data);
    //       if (data.success === 1) {
    //         this.$message.success("上传图片成功");
    //         // this.fileList.url = data.result;
    //         // this.fileList.push({
    //         //   // name: params.file.name,
    //         //   url: data.result
    //         // });
    //         this.ruleForm.imgUrl = data.data[0].oUrl;
    //         console.log("上传的图片文件", this.ruleForm.imgUrl);
    //       } else {
    //         this.$message.error(data.msg);
    //       }
    //     });
    //   } catch (err) {
    //     console.log(err);
    //   }
    // },
    // 提交表单
    commit () {
      this.countNum = 0;
      this.$nextTick(() => {
        this.$refs.ruleForm.validate(valid => {
          console.log("valid", valid);
          if (valid) {
            this.countNum = 1;
            return this.save();
          } else {
            return false;
          }
        });
      });
    },
    // 验证
    validateValue (prop, msgStatus, validateMessage) {
      if (!this.countNum && !msgStatus) {
        this.countNum += 1;
        if (validateMessage) {
          this.$message.error(validateMessage);
        }
      }
    },
    //新增/修改学校信息
    save () {
      let roles = "";
      let lables = "";
      if (this.roleNametags.length !== 0) {
        this.roleNametags.forEach(role => {
          if (roles == "") {
            roles = role.id;
          } else {
            roles = roles + "," + role.id;
          }
        });
      }
      if (this.labletags.length !== 0) {
        this.labletags.forEach(lable => {
          if (lables == "") {
            lables = lable.id;
          } else {
            lables = lables + "," + lable.id;
          }
        });
        console.log('zzzzzzzzzzzzzzzzzz', lables)
      }
      console.log(this.managerList, '12312321')
      try {
        const params = {
          cardName: this.ruleForm.cardName, //卡片名称
          cardSort: this.ruleForm.sort, //卡片顺序
          path: this.upData.uploadPath, //上传部署包的路径【来自上传信息】
          url: this.upData.url, // 访问地址 【来自上传信息】
          packageName: this.upData.packageName, //包名称【来自上传信息】
          version: this.upData.version, //包版本【来自上传信息】
          adminId: this.managerList.map(el => el.adminId).join(','), //管理员的id
          roleId: roles, //角色id，多个角色逗号隔开
          lableId: lables //标签id，多个标签逗号隔开
        };
        add(params).then(res => {
          const data = res.data;
          console.log("这是轮播图新增/编辑接口", data);
          if (data.status === 1000) {
            this.goBack();
            this.$message.success("保存成功");
          } else {
            this.$message.error(data.msg);
          }
        });
      } catch (err) {
        this.$message.error(err);
        console.log(err);
      }
    },
    //表单重置
    resetForm (formName) {
      //   if (this.ID !== null) {
      //     this.$refs[formName].resetFields();
      //   } else {
      this.$refs[formName].resetFields();
      this.fileList = [];
      this.ruleForm.adminId = "";
      this.ruleForm.adminName = "";
      this.ruleForm.jar = "";
      this.ruleForm.roleId = "";
      this.ruleForm.lableId = "";
      this.roleNametags = [];
      this.labletags = [];
      this.upData = {};
      //   }
      console.log("重置", this.ruleForm);
    },
    //关闭授权角色弹窗
    closeDetail () {
      this.detailModal = false;
    },
    //授权角色确定弹窗
    agreeDetail () {
      this.roleTree.forEach(row => {
        if (!row.children) {
          this.roleNametags.push({
            name: row.roleName,
            type: "",
            id: row.id
          });
        }
      });
      this.detailModal = false;
    },
    //关闭授权标签弹窗
    closelable () {
      this.lableTreeModal = false;
    },
    //授权标签确定弹窗
    agreelable () {
      this.lableTree.forEach(row => {
        if (!row.children) {
          this.labletags.push({
            name: row.lableName,
            type: "",
            id: row.id
          });
        }
      });
      this.lableTreeModal = false;
    },
    // 树节点渲染
    renderContent (h, { node, data, store }) {
      console.log(data);
      console.log(store);
      if (data.id === 1) {
        return (
          <span class="custom-tree-node">
            <span style="padding-left: 8px; font-weight: bold;">
              {node.label}
            </span>
          </span>
        );
      } else {
        return (
          <span class="custom-tree-node">
            <span style="padding-left: 8px;">{node.label}</span>
          </span>
        );
      }
    },
    handleCheckChange (data, node) {
      console.log(node.checkedNodes);
      this.lableTree = node.checkedNodes;
      console.log("现在选中的", this.lableTree);
    },
    handlecheckd (data, node) {
      console.log(node.checkedNodes);
      this.roleTree = node.checkedNodes;
      console.log("现在选中的", this.roleTree);
    },
    //新增角色标签
    openRoleName () {
      let roleName = "";
      if (this.roleNametags.length !== 0) {
        this.roleNametags.forEach(row => {
          if (roleName == "") {
            roleName = row.id;
          } else {
            roleName = roleName + "," + row.id;
          }
        });
      }
      //   this.ruleForm.roleId = roleName;
      this.selectTree(roleName);
      this.roleTree = [];
      this.detailModal = true;
    },
    //新增授权标签
    openlableName () {
      let lableName = "";
      if (this.labletags.length !== 0) {
        this.labletags.forEach(row => {
          if (lableName == "") {
            lableName = row.id;
          } else {
            lableName = lableName + "," + row.id;
          }
        });
      }
      //   this.ruleForm.lableId = lableName;
      this.selectlableTree(lableName);
      this.lableTree = [];
      this.lableTreeModal = true;
    },
    //获取角色树树列表
    selectTree (row) {
      try {
        const params = row; //api的id;
        selectTree(params).then(res => {
          const data = res.data;
          console.log("这是卡片使用角色标签详情接口", data);
          if (data.status === 1000) {
            this.treeData = [];
            this.treeData = data.result;
            this.treeData.forEach(element => {
              element.label = element.roleName;
              element.id = element.id;
              element.disabled = element.perm;
              if (element.children) {
                element.children.forEach(elements => {
                  // console.log(elements)
                  elements.label = elements.roleName;
                  elements.id = elements.id;
                  elements.disabled = elements.perm;
                });
              }
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //获取标签树列表
    selectlableTree (row) {
      try {
        const params = row; //api的id;
        selectlableTree(params).then(res => {
          const data = res.data;
          console.log("这是卡片使用角色标签详情接口", data);
          if (data.status === 1000) {
            this.treelableData = [];
            this.treelableData = data.result;
            this.treelableData.forEach(element => {
              element.label = element.lableName;
              element.id = element.id;
              element.disabled = element.perm;
              if (element.children) {
                element.children.forEach(elements => {
                  // console.log(elements)
                  elements.label = elements.lableName;
                  elements.id = elements.lableId;
                  elements.disabled = elements.perm;
                });
              }
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>

<style lang="scss">
.newSlideshow {
  height: 100vh !important;
}
.thisNew {
  .new-task-modal .el-checkbox {
    width: 16px;
  }
  .modal-func-icon {
    display: inline-block;
    margin-left: 8px;
    .el-button {
      width: 13px;
      height: 14px;
      padding: 0 !important;
      margin-left: 0px !important;
    }
    .el-button--medium {
      border-radius: 2px;
    }
    .content-icon-del {
      border: 1px solid #ff3b30;
      color: #ff3b30;
    }
    .content-icon-add {
      margin-left: 16px !important;
      border: 1px solid #3296fa;
      color: #3296fa;
    }
  }
}
</style>
